<template>
<div class="rule">
  <div :class="['header',bgColor == 1 ? 'scrollBg' : '']" v-if="!(orderSource==16 || orderSource==17)"><!-- APP上不展示头部信息 -->
    <div class="imageBlock" @click="goInvite()">
      <img class="return_ico" v-if="bgColor == 0" src="@/assets/images/header/return.png"/>
      <img class="return_ico" v-else  src="@/assets/images/header/returnBlack.png"/>
    </div>
    <span>邀请{{type == 1 ? '车主' : '租客'}}奖励规则</span>
  </div>
  <div class="owner">
    <img v-if="type == 1" src="@/assets/images/rule/owner_bg1.jpg"/>
    <img v-else src="@/assets/images/rule/renter_bg1.jpg"/>
    <div class="ownerCon">
      <div class="title">奖励说明</div>
      <p>1.邀请{{type == 1 ? '车主' : '租客'}}添加共享车辆，邀请人可获得提成奖励；</p>
      <p>2.奖励金额发放至“个人钱包”，可按照平台提现规则提现；</p>
      <p>3.奖励规则如下；</p>
      <img v-if="type == 1" src="@/assets/images/rule/owner_bg2.jpg"/>
      <img v-else src="@/assets/images/rule/renter_bg2.jpg"/>
    </div>
  </div>
</div>
</template>

<script>
import { orderSource } from '@/utils/env';
export default {
  name: "rule",
  data: function () {
    return {
      orderSource: orderSource,
      type: 1,
      bgColor: 0
    }
  },
  created() {
    this.type = this.$route.query.type || 1;
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
    // this.flexible.showToast({
    //   duration: 8000,
    //   content: '我的渠道是' + this.orderSource
    // })
  },
  methods: {
    handleScroll(){
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      let offsetTop = document.querySelector('.rule').offsetTop || 0;
      scrollTop > offsetTop ? this.bgColor = 1 : this.bgColor = 0
    },
    goInvite(){
      this.$router.replace({ path: '/invite', query:{type:this.type} });
    }
  }
}
</script>

<style scoped lang="scss" type="text/scss">
.rule{
  position: absolute;
  top: 0;
  background: #fff;
  height: auto;
  width: 100%;
  overflow: hidden;
  .scrollBg{
    background: #fff;
    color: #000 !important;
  }
  .header{
    position: fixed;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px 0;
    box-sizing: border-box;
    width: 100%;
    height: 110px;
    color: #fff;
    font-size: 30px;
    .imageBlock{
      position: absolute;
      top: 0;
      left: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100px;
      height: 100px;
      .return_ico{
        width: 30px;
        height: 30px;
      }
    }
  }
  .owner{
    img{
      width: 100%;
    }
    .ownerCon{
      padding: 30px;
      box-sizing: border-box;
      .title{
        text-align: center;
        margin-bottom: 10px;
      }
      p{
        margin-bottom: 10px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/index/rule.vue